export default "__VITE_ASSET__DdkAauSA__"